import { create } from "zustand"
import { persist } from "zustand/middleware"

export type UISection = "plain" | "embed" | "json"

type UIStore = {
  accordion: UISection | null
  setAccordion: (accordion: UISection | null) => void
}

export const useUIStore = create<UIStore>()(
  persist(
    set => ({
      accordion: "plain",
      setAccordion: accordion => set({ accordion })
    }),
    {
      name: "ui-data",
      merge: (persistedState, currentState) => {
        const accordion = Array.isArray((persistedState as UIStore)?.accordion)
          ? (persistedState as UIStore).accordion[0] ?? null
          : (persistedState as UIStore)?.accordion ?? null

        return {
          ...currentState,
          ...persistedState,
          accordion: (accordion ?? "plain") as UISection
        }
      }
    }
  )
)
